import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { TOC_LAYOUT, TOC_MODULE_COLORS } from "./constants.js";
import tocHeaderSvg from "../assets/print/toc-header.svg.js";
import shapeYSvg from "../assets/print/shape-y.svg.js";
import shapeCSvg from "../assets/print/shape-c.svg.js";
import shapeRSvg from "../assets/print/shape-r.svg.js";
const BADGE_SHADOW_SVGS = [shapeYSvg, shapeCSvg, shapeRSvg];
const BADGE_NUMBER_BG = ["#FEF1CB", "#DEF2DA", "#FFF2F2"];
function determineTocLayout(modules, tableHeight) {
  const L = TOC_LAYOUT;
  const availablePage1 = tableHeight - L.page1.pt - L.page1.pb - L.headerHeight - L.headerToModuleGap;
  const mod1ContentHeight = L.badgeHeight + L.badgeToListGap + modules[0].lessons.length * (L.lessonGapFirst + 30 + L.lessonInnerGap + 22);
  if (modules.length >= 3) {
    return { type: "three-modules" };
  }
  if (mod1ContentHeight <= availablePage1) {
    return { type: "basic" };
  }
  const lessonRowHeight = L.lessonGapFirst + 30 + L.lessonInnerGap + 22;
  const page1LessonCapacity = Math.floor(
    (availablePage1 - L.badgeHeight - L.badgeToListGap) / lessonRowHeight
  );
  return { type: "overflow", page1LessonCapacity };
}
function TocModuleBadge({
  chapterNumber,
  moduleName,
  color,
  colorIndex = 0
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        position: "relative",
        width: "100%",
        height: TOC_LAYOUT.badgeHeight,
        background: color,
        borderRadius: `${TOC_LAYOUT.badgeRadius}px ${TOC_LAYOUT.badgeRadius}px ${TOC_LAYOUT.badgeRadius}px 0`
      },
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              position: "absolute",
              top: "50%",
              left: TOC_LAYOUT.badgePaddingLeft,
              transform: "translateY(-50%)",
              display: "flex",
              alignItems: "center",
              gap: TOC_LAYOUT.badgeNameGap
            },
            children: [
              /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: TOC_LAYOUT.badgeChapterGap }, children: [
                /* @__PURE__ */ jsx(
                  "span",
                  {
                    className: "font-dunggeunmiso",
                    style: {
                      fontSize: TOC_LAYOUT.badgeChapterFontSize,
                      color: "#fff",
                      fontWeight: 700,
                      lineHeight: "normal"
                    },
                    children: "챕터"
                  }
                ),
                /* @__PURE__ */ jsxs(
                  "div",
                  {
                    style: {
                      position: "relative",
                      width: TOC_LAYOUT.badgeNumberSize,
                      height: TOC_LAYOUT.badgeNumberSize
                    },
                    children: [
                      /* @__PURE__ */ jsx(
                        "div",
                        {
                          style: {
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            background: BADGE_NUMBER_BG[colorIndex] || BADGE_NUMBER_BG[0]
                          }
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        "span",
                        {
                          className: "font-dunggeunmiso",
                          style: {
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            fontSize: TOC_LAYOUT.badgeNumberFontSize,
                            fontWeight: 700,
                            color,
                            lineHeight: "normal"
                          },
                          children: chapterNumber
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(
                "span",
                {
                  className: "font-dunggeunmiso",
                  style: {
                    fontSize: TOC_LAYOUT.badgeNameFontSize,
                    color: "#fff",
                    fontWeight: 700,
                    lineHeight: 1,
                    letterSpacing: "-0.12px",
                    whiteSpace: "nowrap"
                  },
                  children: moduleName
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          "img",
          {
            src: BADGE_SHADOW_SVGS[colorIndex] || BADGE_SHADOW_SVGS[0],
            alt: "",
            width: TOC_LAYOUT.badgeShadowSize,
            height: TOC_LAYOUT.badgeShadowSize,
            style: { position: "absolute", left: 0, top: TOC_LAYOUT.badgeHeight }
          }
        )
      ]
    }
  );
}
function TocLessonRow({
  number,
  lesson,
  color
}) {
  var _a;
  const numStr = String(number).padStart(2, "0");
  const unitParts = lesson.unitInfo.split(new RegExp("(?<=\\.)"));
  const unitLabel = ((_a = unitParts[0]) == null ? void 0 : _a.trim()) || "";
  const unitName = unitParts.slice(1).join(".").trim() || "";
  return /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexDirection: "column", gap: TOC_LAYOUT.lessonInnerGap }, children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          display: "flex",
          alignItems: "center",
          gap: TOC_LAYOUT.lessonRowGap,
          width: "100%"
        },
        children: [
          /* @__PURE__ */ jsxs(
            "span",
            {
              style: {
                fontFamily: "'Pretendard', sans-serif",
                fontWeight: 700,
                fontSize: TOC_LAYOUT.numFontSize,
                color: TOC_LAYOUT.numColor,
                lineHeight: "28px",
                height: 26,
                display: "flex",
                alignItems: "center",
                textAlign: "center",
                flexShrink: 0
              },
              children: [
                /* @__PURE__ */ jsx("span", { style: { width: 11, display: "inline-block", textAlign: "center" }, children: numStr[0] }),
                /* @__PURE__ */ jsx("span", { style: { width: 11, display: "inline-block", textAlign: "center" }, children: numStr[1] })
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            "span",
            {
              style: {
                fontFamily: "'Pretendard', sans-serif",
                fontWeight: 400,
                fontSize: TOC_LAYOUT.titleFontSize,
                color: "#000",
                lineHeight: "26px",
                whiteSpace: "nowrap",
                flexShrink: 0
              },
              children: lesson.lessonName
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                flex: 1,
                minWidth: 20,
                height: 0,
                borderBottom: "2px dotted #d4d4d4",
                alignSelf: "center"
              }
            }
          ),
          /* @__PURE__ */ jsx(
            "span",
            {
              style: {
                fontFamily: "'Pretendard', sans-serif",
                fontWeight: 600,
                fontSize: TOC_LAYOUT.pageFontSize,
                color,
                lineHeight: "26px",
                textAlign: "right",
                whiteSpace: "nowrap",
                flexShrink: 0
              },
              children: lesson.startPage ?? ""
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          display: "flex",
          alignItems: "center",
          gap: TOC_LAYOUT.classRowGap,
          paddingLeft: TOC_LAYOUT.classRowPadLeft,
          fontSize: TOC_LAYOUT.gradeFontSize,
          whiteSpace: "nowrap"
        },
        children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              style: {
                fontFamily: "'Pretendard', sans-serif",
                fontWeight: 700,
                color,
                lineHeight: "normal"
              },
              children: lesson.grade
            }
          ),
          unitLabel && /* @__PURE__ */ jsx(
            "span",
            {
              style: {
                fontFamily: "'Pretendard', sans-serif",
                fontWeight: 500,
                color: TOC_LAYOUT.unitColor,
                lineHeight: "normal"
              },
              children: unitLabel
            }
          ),
          unitName && /* @__PURE__ */ jsx(
            "span",
            {
              style: {
                fontFamily: "'Pretendard', sans-serif",
                fontWeight: 500,
                color: TOC_LAYOUT.unitColor,
                lineHeight: "22px"
              },
              children: unitName
            }
          )
        ]
      }
    )
  ] });
}
function TocLessonList({
  lessons,
  color,
  startNumber,
  gap
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        gap,
        paddingLeft: TOC_LAYOUT.lessonListPadX,
        paddingRight: TOC_LAYOUT.lessonListPadX,
        width: "100%"
      },
      children: lessons.map((lesson, i) => /* @__PURE__ */ jsx(
        TocLessonRow,
        {
          number: startNumber + i,
          lesson,
          color
        },
        i
      ))
    }
  );
}
function TocModuleSection({
  module,
  lessonSlice,
  startNumber = 1,
  isFirst = false,
  showBadge = true
}) {
  const color = TOC_MODULE_COLORS[module.colorIndex] || TOC_MODULE_COLORS[0];
  const lessons = lessonSlice || module.lessons;
  const gap = isFirst ? TOC_LAYOUT.lessonGapFirst : TOC_LAYOUT.lessonGapOther;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: showBadge ? TOC_LAYOUT.badgeToListGap : 0,
        alignItems: "flex-start",
        width: "100%",
        flexShrink: 0
      },
      children: [
        showBadge && /* @__PURE__ */ jsx(
          TocModuleBadge,
          {
            chapterNumber: module.chapterNumber,
            moduleName: module.moduleName,
            color,
            colorIndex: module.colorIndex
          }
        ),
        /* @__PURE__ */ jsx(TocLessonList, { lessons, color, startNumber, gap })
      ]
    }
  );
}
function TocPage({ modules, pageWidth, pageHeight, bleedPx = 0 }) {
  const L = TOC_LAYOUT;
  const totalW = pageWidth + bleedPx * 2;
  const totalH = pageHeight + bleedPx * 2;
  const layout = useMemo(() => determineTocLayout(modules, L.tableHeight), [modules]);
  const pageStyle = {
    position: "relative",
    overflow: "hidden",
    boxSizing: "border-box",
    width: totalW,
    height: totalH,
    background: L.bgColor
  };
  const tableLeft = (totalW - L.tableWidth) / 2;
  const tableTop = (totalH - L.tableHeight) / 2;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "print-page", style: pageStyle, children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          style: {
            position: "absolute",
            left: tableLeft,
            top: tableTop,
            width: L.tableWidth,
            height: L.tableHeight,
            background: "#fff",
            borderTopLeftRadius: L.tableRadius,
            borderBottomLeftRadius: L.tableRadius,
            display: "flex",
            flexDirection: "column",
            gap: L.headerToModuleGap,
            paddingTop: L.page1.pt,
            paddingBottom: L.page1.pb,
            paddingLeft: L.page1.pl,
            paddingRight: L.page1.pr,
            overflow: "hidden"
          },
          children: [
            /* @__PURE__ */ jsx("div", { style: { width: L.headerWidth, height: L.headerHeight, flexShrink: 0 }, children: /* @__PURE__ */ jsx(
              "img",
              {
                src: tocHeaderSvg,
                alt: "CONTENTS 이 책의 차례",
                style: { width: "100%", height: "100%" }
              }
            ) }),
            layout.type === "overflow" && layout.page1LessonCapacity != null ? /* @__PURE__ */ jsx(
              TocModuleSection,
              {
                module: modules[0],
                lessonSlice: modules[0].lessons.slice(0, layout.page1LessonCapacity),
                isFirst: true
              }
            ) : /* @__PURE__ */ jsx(TocModuleSection, { module: modules[0], isFirst: true })
          ]
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            position: "absolute",
            left: tableLeft + L.tableWidth,
            top: tableTop,
            right: 0,
            height: L.tableHeight,
            background: "#fff"
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "print-page", style: pageStyle, children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          style: {
            position: "absolute",
            left: tableLeft,
            top: tableTop,
            width: L.tableWidth,
            height: L.tableHeight,
            background: "#fff",
            borderTopRightRadius: L.tableRadius,
            borderBottomRightRadius: L.tableRadius,
            display: "flex",
            flexDirection: "column",
            gap: L.moduleToModuleGap,
            paddingLeft: L.page2.pl,
            paddingRight: L.page2.pr,
            overflow: "hidden",
            ...layout.type === "three-modules" ? { justifyContent: "center" } : { paddingTop: L.page2.pt }
          },
          children: [
            layout.type === "basic" && modules[1] && /* @__PURE__ */ jsx(TocModuleSection, { module: modules[1] }),
            layout.type === "overflow" && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                TocModuleSection,
                {
                  module: modules[0],
                  lessonSlice: modules[0].lessons.slice(layout.page1LessonCapacity),
                  startNumber: (layout.page1LessonCapacity ?? 0) + 1,
                  showBadge: false,
                  isFirst: true
                }
              ),
              modules[1] && /* @__PURE__ */ jsx(TocModuleSection, { module: modules[1] })
            ] }),
            layout.type === "three-modules" && /* @__PURE__ */ jsxs(Fragment, { children: [
              modules[1] && /* @__PURE__ */ jsx(TocModuleSection, { module: modules[1] }),
              modules[2] && /* @__PURE__ */ jsx(TocModuleSection, { module: modules[2] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            position: "absolute",
            left: 0,
            top: tableTop,
            width: tableLeft,
            height: L.tableHeight,
            background: "#fff"
          }
        }
      )
    ] })
  ] });
}
export {
  TocPage
};
//# sourceMappingURL=TocPage.js.map
